/* eslint-disable global-require */

// TODO: search for an alternative to "require"
if (process.env.NODE_ENV === 'production') {
    module.exports = require('./configureStore.prod');
} else {
    module.exports = require('./configureStore.dev');
}
